import React from 'react';
import Footer from '../components/Layout/Footer';
import SearchModal from '../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../components/Common/Breadcumb';
import DetailsHeader from '../components/Layout/Header/DetailsHeader';
import CorporateLegacy from './sections/CorporateLegacy';

// Breadcrumbs Background Image
import bannerbg from '../assets/img/bg/tech-bg.png';

const PastPerformance = () => {
    return (
        <React.Fragment>
            <DetailsHeader parentMenu='page' secondParentMenu='past-performance' activeMenu='/past-performance' />
            <SiteBreadcrumb
                pageTitle="Past Performance"
                titleClass="page-title"
                pageName="Past Performance"
                breadcrumbsImg={bannerbg}
            />

            <div className="container ">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1 pt-20">
                        <h3>Predecessor Sources</h3>
                        <p className="small muted">For public context on predecessor experience and corporate clients, see the PSA Corporate Profile. Excerpted highlights are presented below for reference.</p>
                        <p>
                            PSA's corporate profile documents prime and subcontractor experience since 1989 and lists corporate clients such as Dupont, Northrop Grumman, IBM, and others. It also enumerates government certifications and awards and reinforces the predecessor's long-running federal and commercial engagements.
                        </p>
                        <p>
                            Source: <a href="http://www.psa-inc.com/corporate-profile/" target="_blank" rel="noopener noreferrer">PSA Corporate Profile</a>
                        </p>
                    </div>
                </div>
            </div>

            <CorporateLegacy />

            <Footer />
            <SearchModal />
        </React.Fragment>
    )
}

export default PastPerformance;
